<template>
  <a-modal :title="title" v-model="visible" @ok="handleOk" @cancel="handleCancel" :width="460"
    class="print-page-footer-model">
    <div class="table-td-list" v-if="notFooterArray.length>0">
      <div class="selected">
        <a-checkbox-group @change="onChange">
          <a-row v-for="(item,index) in notFooterArray" :key="index">
            <a-col :span="8">
              <a-checkbox :value="item.title">
                <span>{{ item.title }}</span>
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
    </div>
    <div class="not-table-td-list" v-else>
      <span>暂无可添加表头信息</span>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "printPageFooter",
  data() {
    return {
      title: "可添加表头信息",
      visible: false,
      value: null,
      type: null,
      notFooterArray: [],
      selectData: [],
    };
  },
  methods: {
    show(notFooterArray, type) {
      this.visible = true;
      this.value = null;
      this.type = type;
      this.notFooterArray = notFooterArray ? notFooterArray : [];
    },
    onChange(e) {
      this.selectData = [];
      this.notFooterArray.map((item) => {
        e.map((ite) => {
          if (item.title == ite) {
            this.selectData.push(item);
          }
        });
      });
      console.log(this.selectData);
    },
    handleCancel() {
      this.visible = false;
    },
    handleOk() {
      this.visible = false;
      this.$emit("btnSelectAddFooter", this.selectData, this.type);
    },
  },
};
</script>
<style lang="scss">
.print-page-footer-model {
  .ant-modal-body {
    padding: 0 36px;
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      border: 1px solid #e6e6e6;
      border-bottom: 0;
      .ant-row {
        width: 100%;
        padding: 15px 10px;
        border-bottom: 1px solid #e6e6e6;
      }
      .ant-col {
        width: 100%;
        .ant-checkbox-wrapper {
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
    .not-table-td-list {
      min-height: 100px;
      border: 1px solid #e6e6e6;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ant-modal-footer {
    padding: 30px 0;
  }
}
</style>
